import { render, staticRenderFns } from "./InfoMsg.vue?vue&type=template&id=f379dcaa&scoped=true&"
import script from "./InfoMsg.vue?vue&type=script&lang=js&"
export * from "./InfoMsg.vue?vue&type=script&lang=js&"
import style0 from "./InfoMsg.vue?vue&type=style&index=0&id=f379dcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379dcaa",
  null
  
)

export default component.exports